export default __webpack_public_path__ + "static/media/Synapes_logo_2.dd46f1ec.png";